import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * One "Clear all" button for a filter bar. The host resets its own form on `(clear)`. It should also
 * call `forgetFilters` and clear the filter query params, so a cleared view stays cleared on reload.
 */
@Component({
  selector: 'app-filter-clear-all',
  standalone: true,
  template: `
    <button type="button" class="btn btn-link" [disabled]="disabled" (click)="clear.emit()">Clear all</button>
  `
})
export class FilterClearAllComponent {
  /** Disable when nothing is filtered. */
  @Input() disabled: boolean = false;
  @Output() clear = new EventEmitter<void>();
}
